import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';

import AddEntityCard from '@ts-core/components/AddEntityCard';

import AssignmentsListSection from './AssignmentsListSection';

const AssignmentsList = (props) => {
  const {
    sections: pSections,
    loading,
    onToggleSection,
    isSectionOpen,
    onToggleAssignment,
    onSelectAssignment,
    onRemoveAssignment,
    onSendAssignment,
    onEditAssignment,
    onCreateAssignment,
  } = props;

  const sections = loading ? Array.from(new Array(1)) : pSections;

  return (
    <div>
      <Box pb={9}>
        {sections.length === 0 && !loading && (
          <Box mt={2} maxWidth={320}>
            <AddEntityCard
              onAdd={onCreateAssignment}
              message={
                <FormattedMessage
                  id="assignments.createNewCard"
                  variant="body2"
                />
              }
            />
          </Box>
        )}
        {sections.map((section, index) => (
          <AssignmentsListSection
            key={index}
            section={section}
            loading={loading}
            open={loading || isSectionOpen(section)}
            onToggleSection={onToggleSection}
            onToggleAssignment={onToggleAssignment}
            onSelectAssignment={onSelectAssignment}
            onRemoveAssignment={onRemoveAssignment}
            onSendAssignment={onSendAssignment}
            onEditAssignment={onEditAssignment}
          />
        ))}
      </Box>
    </div>
  );
};

AssignmentsList.propTypes = {
  loading: PropTypes.bool,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      assignments: PropTypes.array.isRequired,
    })
  ),

  onToggleSection: PropTypes.func.isRequired,
  isSectionOpen: PropTypes.func.isRequired,

  onCreateAssignment: PropTypes.func.isRequired,
  onToggleAssignment: PropTypes.func.isRequired,
  onSelectAssignment: PropTypes.func.isRequired,
  onRemoveAssignment: PropTypes.func.isRequired,
  onSendAssignment: PropTypes.func.isRequired,
  onEditAssignment: PropTypes.func.isRequired,
};

AssignmentsList.defaultProps = {
  loading: false,
  sections: [],
};

export default AssignmentsList;
